import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { Tarifa } from '../clases/tarifa';
import { RequestServicio } from '../clases/request-servicio';
import { ResponseServicio } from '../clases/response-servicio';
import { CancelarServicio } from '../clases/cancelar-servicio';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { TipoPago } from '../clases/tipo-pago';
import { Theme, light, dark } from "../interface/theme";
@Injectable({
  providedIn: 'root'
})
export class SolicitarServicioService {

  private tipoPago$: BehaviorSubject<TipoPago[]> = new BehaviorSubject<TipoPago[]>([]);
  private tipoServicio$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    private tipovehiculo$:BehaviorSubject<any[]>= new BehaviorSubject<any[]>([])
  // Mensaje de retorno
  messageRetorno : string 
  retornoId : number = 0
  retornoFlag : boolean;
  


  private active: Theme = light;
  private availableThemes: Theme[] = [light, dark];


  
  constructor(private _http: HttpClient) {
  }
  setLightTheme(): void {
    this.setActiveTheme(light);
  }

  setActiveTheme(theme: Theme): void {
    this.active = theme;

    Object.keys(this.active.properties).forEach(property => {
      document.documentElement.style.setProperty(
        property,
        this.active.properties[property]
      );
    });
  }


  requestDireccion(lat: any, lng: any) {
    const url = environment.URL_BASE + 'geocodeAuthorization/json?latlng=' + lat + ',' + lng;
    return this._http.get(url);
  }

  requestDireccionDefault(lat: any, lng: any) {
    const url = environment.URL_BASE + 'geocodeAuthorization/json?latlng=' + lat + ',' + lng;
    return this._http.get(url);
  }

  requestTarifa(json: any) {
    //console.log(json);
    const url = environment.URL_BASE + "tarifaAuthorization/consultar";
    console.log(json);
    return this._http.post(url, json);
  }

  requestCrearServicio(json: RequestServicio) {
    const url = environment.URL_BASE + "servicioAuthorization/multiSave";
    return this._http.post(url, json);
  }

  requestObtenerConductor(json: ResponseServicio) {
    const url = environment.URL_BASE + "servicioAuthorization/consultar";
    return this._http.post(url, json);
  }

  requestObtenerConductorDirecto(json: ResponseServicio) {
    const url = environment.URL_BASE + "servicioAuthorization/wmConsultarEstadoDespachador";
    return this._http.post(url, json);
  }
  
  getTipoPago(){
    return this.tipoPago$;
  }

  requestCancelarServicio(json: CancelarServicio) {
    const url = environment.URL_BASE + "servicioAuthorization/anular";
    return this._http.post(url, json);
  }

  requestTipoPago(IdCliente: any, isoCountryCode: string) {
    const url = environment.URL_BASE + "tipoPagoAuthorization/all?id=" + IdCliente + '&isoCountryCode=' + isoCountryCode;
    return this._http.get(url);
  }

  requestTipoPagoEmpresa(IdEmpresa) {
    const url = environment.URL_BASE + "tipoPagoAuthorization/all?idEmpresa=" + IdEmpresa;
    return this._http.get(url);
  }

  requestTipoPagoAll(IdCliente: any) {
    const url = environment.URL_BASE + "tipoPagoAuthorization/all?id=" + IdCliente;
    return this._http.get(url).pipe(
      map( (res: any) =>{
        this.tipoPago$.next(res);
        return res;
      })
    );
  }

  requestTipoReporte(IdEmpresa) {
    const url = environment.URL_BASE + "tipoPago/getTipoReporte?idEmpresa=" + IdEmpresa;
    return this._http.get(url);
  }

  requestGeocerca(idEmpresa: any) {
    const url = environment.URL_BASE + "usuarioAuthorization/obtenergeocercas?idEmpresa=" + idEmpresa;
    return this._http.get(url);
  }

  requestTipoServicio(IdCliente: any) {
    const flagDelivery = environment.DELIVERY
    const url = environment.URL_BASE + "tiposervicio/all?id="+ IdCliente + "&FlagDelivery=" + flagDelivery;

    return this._http.get(url).pipe(
      map( (res: any) =>{
        this.tipoServicio$.next(res);
        return res;
      })
    );
  }

  getTiposervicio(){
    const url = environment.URL_BASE + "tiposervicio/all"
    return this._http.get(url);
  }

  getZona(json: any){
    const url = environment.URL_BASE + "ZonaAuthorization/listarZonas"
    return this._http.post(url, json);
  }

  requestTipoVehiculos(){
    const url =environment.URL_BASE+"TipoVehiculoAuthorization/all";
    return this._http.get(url).pipe(
      map((res:any)=>{
        this.tipovehiculo$.next(res);
        return res;
      })
    )
  }

  getTipoServicio(){
    return this.tipoServicio$;
  }
 
  // consultarCodigo(IdCliente: any){
  //   const url = environment.URL_BASE + "promocion/wmObtenerPromocionCliente" +"?idCliente=" + IdCliente;
  //   return this._http.get(url);
  // }

  // requestCountry() {
  //   const url = environment.URL_GET_COUNTRY;
  //   return this._http.get(url).pipe(
  //     map((data: any) => {
  //       return data;
  //     })
  //   );
  // }

  requestCountryCode(latitud:number, longitud:number){
    const url = environment.URL_BASE + 'servicio/getCobertura?latitud=' +  latitud + '&longitud=' + longitud;
    return this._http.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  requestLstPersonal(IdCliente: any) {
    const url = environment.URL_BASE + "cliente/listarPersonal?idCliente="+ IdCliente;
    return this._http.get(url);
  }

  requestTipoServicioEmpresa(idEmpresa: any){
    const url = environment.URL_BASE + "tiposervicio/getTipoReporte?idempresa="+ idEmpresa;
    return this._http.get(url);
  }

  requestLstPersonalAutocomplete(IdCliente: any, busqueda: string) {
    const url = environment.URL_BASE + "cliente/listarPersonalAutocomplete?idCliente="+ IdCliente+"&busqueda="+busqueda;
    return this._http.get(url);
  }

  conductoresCercanos(lat: any, lng: any, tipoServicio: any) {
    var data={
      lat: lat,
      lng :lng,
      tipoServicio : (tipoServicio)?tipoServicio:-1

    }
    const url = environment.URL_BASE + "trackingAuthorization/ConsultaConductoresTracking"//?lat="+ lat +"&lng=" + lng +"&tipoServicio="+ tipoServicio;
    return this._http.post(url,data);
  }

  obtenerInformacionServicio(idServicio: number){
    const url = environment.URL_BASE + `/servicio/curso?idServicio=${idServicio}`;
    return this._http.get(url);
  }

  requestSaveDatos(json: RequestServicio[]) {
    const url = environment.URL_BASE + "servicioAuthorization/multisaveCarga";
    return this._http.post(url, json);
  }

  ObtenetRestriccionServicio(data: any){
    const url = environment.URL_BASE +'servicioAuthorization/validarRestriccion'
    return this._http.post(url,data)
  }

  requestPosicionConductorDistancia(idServicio:number) {
    var url = environment.URL_BASE+"DistanciaConductor/wmdistanciaConductor?idServicio="+idServicio;
    return this._http.get(url);
  }
  obtenerPosicionGoogle(origen:string, destino:string) {
    var url = environment.URL_BASE+"/DistanciaConductor/wmposicionConductor?origen="+origen+"&destino="+destino;
    return this._http.get(url);
  }

  enviarNotificacionReserva(idServicio:any){
    const url=environment.URL_BASE+'Notificacion/NotificacionReserva?IdServicio='+idServicio;
    return this._http.get(url)
  }

  requestLstSedes(IdEmpresa: any) {
    const url = environment.URL_BASE + "/api/sedes/all?idEmpresa"+ IdEmpresa;
    return this._http.get(url);
  }
}
